import { Components, Theme } from '@mui/material';

const makeMuiStep = (theme: Theme): Components['MuiStep'] => ({
  styleOverrides: {
    root: { paddingLeft: 0, paddingRight: theme.spacing(3) },
  },
});

export default makeMuiStep;
